// uat
// export const BASE_URL = "http://internal-gateway1.sit.digitalkidu.bt:8082/sit";

// prod
export const BASE_URL =
  "https://nonbanking-api-gateway.digitalkidu.bt:8082/api";

export const HEADERS = {
  "Content-Type": "application/json",
  // uat
  // "X-gravitee-api-key": "b619337d-d703-4277-a988-116a77046911",

  // prod
  "X-gravitee-api-key": "96ea0f0a-355b-4104-a528-98d5bb4efa26",
};

export const LoginUser = `${BASE_URL}/leave/user/login`;
export const GetUser = `${BASE_URL}/leave/user/getAll`;
export const GetLocation = `${BASE_URL}/leave/location/getAll`;
export const AddLocation = `${BASE_URL}/leave/location/create`;
export const LocationNameCheck = `${BASE_URL}/leave/location_name/check`;
export const DeleteLocation = `${BASE_URL}/leave/location/delete`;
export const UpdatOneUser = `${BASE_URL}/leave/user/update`;
export const EditLocation = `${BASE_URL}/leave/location/update`;
export const GetDepartment = `${BASE_URL}/leave/department/getAll`;
export const GetDepartmentwithHead = `${BASE_URL}/leave/departmentwithhead/getAll`;
export const AddDepartment = `${BASE_URL}/leave/department/create`;
export const DeleteDepartment = `${BASE_URL}/leave/department/delete`;
export const GetEmployeeType = `${BASE_URL}/leave/employeetype/getAll`;
export const GetGeneralPeferences = `${BASE_URL}/leave/general/getAll`;
export const UpdateGeneralPeference = `${BASE_URL}/leave/organization/general/update`;
export const AddEmployeeType = `${BASE_URL}/leave/employeetype/create`;
export const EmployeeTypeNameCheck = `${BASE_URL}/leave/employeetype_name/check`;
export const EditEmployeeType = `${BASE_URL}/leave/employeetype/update`;
export const DeleteEmployeeType = `${BASE_URL}/leave/employeetype/delete`;
export const AddEmployeeStatus = `${BASE_URL}/leave/employeestatus/create`;
export const EmployeeStatusNameCheck = `${BASE_URL}/leave/employeestatus_name/check`;
export const EditEmployeeStatus = `${BASE_URL}/leave/employeestatus/update`;
export const GetEmployeeStatus = `${BASE_URL}/leave/employeestatus/getAll`;
export const DeleteEmployeeStatus = `${BASE_URL}/leave/employeestatus/delete`;
export const AddRoles = `${BASE_URL}/leave/role/create`;
export const EditRoles = `${BASE_URL}/leave/role/update`;
export const checkRoles = `${BASE_URL}/leave/role_name/check`;
export const EmployeeCodeCheck = `${BASE_URL}/leave/employee_code/check`;
export const GetRoles = `${BASE_URL}/leave/role/getAll`;
export const DeleteRoles = `${BASE_URL}/leave/role/delete`;
export const AddExtrnalUser = `${BASE_URL}/leave/externaluser/create`;
export const GetExternalUser = `${BASE_URL}/leave/externaluser/getAll`;
export const DeleteExternalUser = `${BASE_URL}/leave/externaluser/delete`;
export const GetLeaveType = `${BASE_URL}/leave/leavetype/getAll`;
export const AddLeaveTypes = `${BASE_URL}/leave/leavetype/create`;
export const LeaveTypeNameCheck = `${BASE_URL}/leave/leave_type_name/check`;
export const DeleteLeaveTypes = `${BASE_URL}/leave/leavetype/delete`;
export const EditLeaveTypes = `${BASE_URL}/leave/leavetype/update`;
export const GetLeavePolicy = `${BASE_URL}/leave/leavepolicy/getAll`;
export const AddLeavePolicys = `${BASE_URL}/leave/leavepolicy/create`;
export const DeleteLeavePolicy = `${BASE_URL}/leave/leavepolicy/delete`;
export const AddHolidayCalendar = `${BASE_URL}/leave/holidaycalendar/create`;
export const GetHolidayCalendar = `${BASE_URL}/leave/holidaycalendar/getAll`;
export const AddHolidayList = `${BASE_URL}/leave/holidaylist/create`;
export const HolidayListUpdate = `${BASE_URL}/leave/holidaylist/update`;
export const GetHolidayList = `${BASE_URL}/leave/holidaylist/getAll`;
export const DeleteHolidayList = `${BASE_URL}/leave/holidaylist/delete`;
export const EditHolidayCalendars = `${BASE_URL}/leave/holidaycalendar/update`;
export const DeleteHolidayCalendar = `${BASE_URL}/leave/holidaycalendar/delete`;
export const GetWorkingType = `${BASE_URL}/leave/workingtype/getAll`;
export const AddWorkingType = `${BASE_URL}/leave/workingtype/create`;
export const WorkingTypeNameCheck = `${BASE_URL}/leave/working_type_name/check`;
export const EditWorkingType = `${BASE_URL}/leave/workingtype/update`;
export const GetCompanySize = `${BASE_URL}/leave/sizeofcompany/getAll`;
export const GetCompanyLogo = `${BASE_URL}/leave/get_general_company_logo`;
export const GeneratePassword = `${BASE_URL}/leave/generate/password`;
export const DeleteWorkingType = `${BASE_URL}/leave/workingtype/delete`;
export const UserRegistration = `${BASE_URL}/leave/organization/register`;
export const checkOrgName = `${BASE_URL}/leave/organization_name/check`;
export const checkOrgCode = `${BASE_URL}/leave/organization_code/check`;
export const GetCountryPhoneCode = `${BASE_URL}/leave/countrycode/getAll`;
export const GetLeaveApproval = `${BASE_URL}/leave/leave_approval/getAll`;
export const changePassword = `${BASE_URL}/leave/user/forgot_password/change_password`;
export const passwordChange = `${BASE_URL}/leave/user/change_password`;
export const ForgotPassword = `${BASE_URL}/leave/user/forgot_password`;
export const CreateUserAccount = `${BASE_URL}/leave/user/create`;
export const CheckUserEmail = `${BASE_URL}/leave/check/user_email`;
export const GetenabledLeave = `${BASE_URL}/leave/leavetype/getenabled`;
export const GetavailableLeave = `${BASE_URL}/leave/available_leave/getAll`;
export const submitLeaveRequest = `${BASE_URL}/leave/leave_request/create`;
export const submitforothers = `${BASE_URL}/leave/other_leave_request/create`;
export const monthlyuserreport = `${BASE_URL}/leave/monthly_data/getAll`;
export const leaverequestview = `${BASE_URL}/leave/leave_request/getAll`;
export const LeaveRequestNotification = `${BASE_URL}/leave/leave_request_notification/getAll`;
export const LeaveRequestApprove = `${BASE_URL}/leave/leave_request/update`;
export const EditExternalUser = `${BASE_URL}/leave/externaluser/update`;
export const DeleteUsers = `${BASE_URL}/leave/user/delete `;
export const AddOfficiating = `${BASE_URL}/leave/officiating/create `;
export const EditDepartment = `${BASE_URL}/leave/department/update`;
export const UpdateLeavepolicy = `${BASE_URL}/leave/leavepolicy/update`;
export const UpdateOrganization = `${BASE_URL}/leave/orgdetail/update`;
export const GetOrganization = `${BASE_URL}/leave/orgdetail/getAll`;
export const CreateLeaveSetting = `${BASE_URL}/leave/leavesetting/create`;
export const GetRestrictedDateSet = `${BASE_URL}/leave/restricted_date_set/getAll`;
export const GetRestrictedDate = `${BASE_URL}/leave/restricted_date/getAll`;
export const EditResDate = `${BASE_URL}/leave/restricted_date/update`;
export const DeleteRestrictedDate = `${BASE_URL}/leave/restricteddate/delete`;
export const CreateRestrictedDate = `${BASE_URL}/leave/restricteddate/create`;
export const CraeteRestrictedDate = `${BASE_URL}/leave/restricteddate/create`;
export const UpdateNotificationPreference = `${BASE_URL}/leave/notificationpreference/update`;
export const GetNotificationPreference = `${BASE_URL}/leave/notificationpreference`;
export const GetLeaveSettingAll = `${BASE_URL}/leave/leavesetting/getAll`;
export const UpdateLeaveSetting = `${BASE_URL}/leave/leavesetting/update`;
export const createSetting = `${BASE_URL}/leave/leavesetting/create`;
export const GetAllHead = `${BASE_URL}/leave/head/getAll`;
export const GetAllInactiveUser = `${BASE_URL}/leave/inactiveuser/getAll`;
export const CreatInactiveUser = `${BASE_URL}/leave/user/reactivate`;
export const DeleteLeaveRequest = `${BASE_URL}/leave/leave_request/delete`;
export const UpdateLeavesettingNew = `${BASE_URL}/leave/leavesettingnew/create`;
export const UserReport = `${BASE_URL}/leave/user/user_details`;
export const LeaveReport = `${BASE_URL}/leave/user/leave_history`;
export const UserLeaveRequest = `${BASE_URL}/leave/user/available_leave`;
export const getSubscriptionPlanDetals = `${BASE_URL}/leave/subscriptionplan/getAll`;
export const accountSubscription = `${BASE_URL}/leave/subscriptionplan/choose`;
export const orgSubscriptioDetails = `${BASE_URL}/leave/org_subscriptionplan/getall`;
export const superuserGetOrganizationStatistics = `${BASE_URL}/leave/dashboard/details`;
export const superuserGetOrganizationGetAll = `${BASE_URL}/leave/organization/getall`;
export const DeactivateAccount = `${BASE_URL}/leave/organization/deactivate`;
export const DefaultLogo = `${BASE_URL}/leave/get_general_company_logo/default`;
export const SubscriptionNormal = `${BASE_URL}/leave/subscriptionplan/normal`;
export const SubscriptionUpgrade = `${BASE_URL}/leave/subscriptionplan/upgrade`;
export const NormalVerifyOTP = `${BASE_URL}/leave/normal_subscription/otp`;
export const UpgradeVerifyOTP = `${BASE_URL}/leave/upgrade_subscription/otp`;
export const SubscribeOuter = `${BASE_URL}/leave/subscriptionplan/outer`;
export const OtpVerifyOuter = `${BASE_URL}/leave/outer_subscription/otp`;

export const HEADERS1 = {
  "Content-Type": "image/png",
};
const USER_ID_KEY = "user_id";
export const setUserId = (userId) => {
  localStorage.setItem(USER_ID_KEY, userId);
};
export const getUserId = () => {
  return localStorage.getItem(USER_ID_KEY);
};
export const removeUserId = () => {
  localStorage.removeItem(USER_ID_KEY);
};
const ORG_ID_KEY = "organization_id";
export const setOrgId = (OrgId) => {
  localStorage.setItem(ORG_ID_KEY, OrgId);
};
export const getOrgId = () => {
  return localStorage.getItem(ORG_ID_KEY);
};
export const removeOrgId = () => {
  localStorage.removeItem(ORG_ID_KEY);
};
const LeaP_ID_KEY = "leavepolicy_id";
export const setLeaPId = (LeaPId) => {
  localStorage.setItem(LeaP_ID_KEY, LeaPId);
};
export const getLeaPId = (LeaPIdLeaPId) => {
  return localStorage.getItem(LeaP_ID_KEY);
};
export const removeLeaPId = () => {
  localStorage.removeItem(LeaP_ID_KEY);
};
const Leave_ID_KEY = "leavetype_id";
export const setLeaveTypeId = (LeaveTypeId) => {
  localStorage.setItem(Leave_ID_KEY, LeaveTypeId);
};
export const getLeaveTypeId = (LeaveTypeId) => {
  return localStorage.getItem(Leave_ID_KEY);
};
export const removeLeaveTypeId = () => {
  localStorage.removeLeaveTypeId(Leave_ID_KEY);
};
const Dep_ID_KEY = "department_id";
export const setDepId = (DepId) => {
  localStorage.setItem(Dep_ID_KEY, DepId);
};
export const getDepId = (DepId) => {
  return localStorage.getItem(Dep_ID_KEY);
};
export const removeDepId = () => {
  localStorage.removeDepId(Dep_ID_KEY);
};

const DNAME_ID_KEY = "department_name";
export const setDname = (Dname) => {
  localStorage.setItem(DNAME_ID_KEY, Dname);
};

export const getDname = (Dname) => {
  return localStorage.getItem(DNAME_ID_KEY);
};
const USER_EMAIL_KEY = "user_email";

export const setUserEmail = (user_email) => {
  localStorage.setItem(USER_EMAIL_KEY, user_email);
};

export const getUserEmail = () => {
  return localStorage.getItem(USER_EMAIL_KEY);
};
// console.log("dsaf", getUserEmail());

const FNAME_ID_KEY = "first_name";

export const setFname = (Fname) => {
  localStorage.setItem(FNAME_ID_KEY, Fname);
};

export const getFname = (Fname) => {
  return localStorage.getItem(FNAME_ID_KEY);
};

//
const LNAME_ID_KEY = "last_name";

export const setLname = (Lname) => {
  localStorage.setItem(LNAME_ID_KEY, Lname);
};

export const getLname = (Lname) => {
  return localStorage.getItem(LNAME_ID_KEY);
};

const EMPLOYEE_CODE = "employee_code";

export const setempcode = (Lname) => {
  localStorage.setItem(EMPLOYEE_CODE, Lname);
};

export const getempcode = (Lname) => {
  return localStorage.getItem(EMPLOYEE_CODE);
};

const SET_ID_KEY = "set_id";

export const setsetId = (setId) => {
  localStorage.setItem(SET_ID_KEY, setId);
};

export const getsetId = () => {
  return localStorage.getItem(SET_ID_KEY);
};

export const removesetId = () => {
  localStorage.removeLeaveTypeId(SET_ID_KEY);
};
const ROLE_KEY = "user_role_name";
export const setroleName = (roleID) => {
  localStorage.setItem(ROLE_KEY, roleID);
};
export const getroleName = () => {
  return localStorage.getItem(ROLE_KEY);
};
const HEAD_KEY = "is_head";
export const setHeadId = (headID) => {
  localStorage.setItem(HEAD_KEY, headID);
};

export const getHeadId = () => {
  return localStorage.getItem(HEAD_KEY);
};
